/**
 * Firebase Logger Silencer
 * Patches Firebase's internal logger BEFORE SDK loads
 * Prevents connection error messages from appearing
 */

if (typeof window !== 'undefined') {
  // Patch window.console immediately
  const originalError = console.error;
  const originalWarn = console.warn;

  // List of exact error patterns to suppress
  const suppressionPatterns = [
    'Could not reach Cloud Firestore backend',
    'WebChannelConnection',
    'transport errored',
    'code=unavailable',
    '@firebase/firestore',
    'offline mode',
    'healthy Internet connection',
  ];

  const shouldSuppress = (msg: string): boolean => {
    if (!msg) return false;
    const msgLower = String(msg).toLowerCase();
    return suppressionPatterns.some(pattern => 
      msgLower.includes(pattern.toLowerCase())
    );
  };

  // Override console.error
  console.error = function(...args: any[]) {
    const firstArg = String(args[0] || '');
    if (!shouldSuppress(firstArg)) {
      originalError.apply(console, args);
    }
  };

  // Override console.warn
  console.warn = function(...args: any[]) {
    const firstArg = String(args[0] || '');
    if (!shouldSuppress(firstArg)) {
      originalWarn.apply(console, args);
    }
  };

  // Also intercept Firebase's logger directly via global config
  (window as any).__FIREBASE_LOGGING_ENABLED__ = false;
  (window as any).__FIREBASE_LOG_LEVEL__ = 'error';
}

export {};
